import { getWebAutoInstrumentations } from "@opentelemetry/auto-instrumentations-web";
import type {
  Instrumentation,
  InstrumentationConfig,
} from "@opentelemetry/instrumentation";

export const configDefaults = {
  ignoreNetworkEvents: true,
  propagateTraceHeaderCorsUrls: [
    /^https?:\/\/([a-zA-Z0-9-]+\.)?medbill\.ai\/api\/.*/,
    /^https?:\/\/([a-zA-Z0-9-]+\.)?grantedhealth\.com\/api\/.*/,
    /^https?:\/\/localhost:[0-9]+\/api\/.*/,
  ],
};

/**
 * Telemetry egress and SDK background chatter. The Honeycomb entry closes a
 * feedback loop rather than trimming noise: the fetch and XHR instrumentations
 * trace the OTLP upload, and that span's export is another upload. Any client
 * exporter added later belongs here. See docs/TELEMETRY.md.
 */
export const ignoreUrls = [
  /api\.honeycomb\.io/,
  /events\.launchdarkly\.com/,
  /clientstream\.launchdarkly\.com/,
];

export function getInstrumentations(): Instrumentation<InstrumentationConfig>[] {
  // document-load describes app startup, so it has no request URL to match.
  const networkDefaults = { ...configDefaults, ignoreUrls };
  return getWebAutoInstrumentations({
    "@opentelemetry/instrumentation-xml-http-request": networkDefaults,
    "@opentelemetry/instrumentation-fetch": networkDefaults,
    "@opentelemetry/instrumentation-document-load": configDefaults,
    "@opentelemetry/instrumentation-user-interaction": { enabled: false },
  });
}
